import loadable from '@loadable/component';

export const ElectronicTradingWidgetLoadable = loadable.lib(() => import('@cian/frontend-electronic-trading-widget'), {
  ssr: false,
});

ElectronicTradingWidgetLoadable.displayName = 'ElectronicTradingWidgetLoadable';
